/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.platinium.socle.ts
 *
 * Messages du SOCLE de l'offre Platinium (chantier Platinium, vague 0,
 * cahier des charges app/docs/CDC-PLATINIUM.md) :
 *   - le droit virtuel /admin/platinium-grant et la section « platinium. »
 *     de l'écran Réglages ;
 *   - le statut d'une entreprise (colonne de l'écran Exposants, compteur) ;
 *   - l'encart « Passer Platinium » de Mon stand ;
 *   - l'écran /exposant/platinium : titre, onglets, garde (pas Platinium,
 *     fenêtre fermée) ;
 *   - le texte de l'accord du candidat, COMMUN au formulaire (lot P2) et à
 *     Mon profil (lot P1) : un seul libellé, pour qu'un accord dise partout
 *     la même chose.
 *
 * Un fichier par lot (décision de la vague 0) : chaque agent n'écrit que
 * dans le sien (fr.platinium.profil, .recherche, .vivier, .entretiens,
 * .pilotage). Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom, lieu ni type d'événement écrit en
 * dur. Le type passe par {eventTypeDef}, appliqué par la table d'identité.
 *
 * Mikael - chef de projet - 2026-10-14
 */
export const messagesPlatiniumSocleFr: Record<string, string> = {
  // ── Back-office : droit et réglages ────────────────────────────────────
  'adminNav.right.platiniumGrant': 'Accorder le Platinium',
  'settingsAdmin.section.platinium': 'Platinium (après l’événement)',

  // ── Statut d'une entreprise ────────────────────────────────────────────
  'platinium.statut.aucun': 'Non',
  'platinium.statut.demande': 'Demande en attente',
  'platinium.statut.actif': 'Platinium',
  'platinium.statut.refuse': 'Refusé',
  'platinium.statut.retire': 'Retiré',

  // ── Écran Exposants : colonne, compteur, décisions ─────────────────────
  'platinium.colonne': 'Platinium',
  'platinium.compteur.aide': 'Entreprises Platinium actives, sur le plafond fixé dans les réglages.',
  'platinium.compteur.sansPlafond': 'sans plafond',
  'platinium.demandeLe': 'demandé le {date}',
  'platinium.action.activer': 'Passer Platinium',
  'platinium.action.valider': 'Valider le Platinium',
  'platinium.action.refuser': 'Refuser le Platinium',
  'platinium.action.retirer': 'Retirer le Platinium',
  'platinium.action.plafond': 'Le plafond d’entreprises Platinium est atteint.',
  'platinium.toast.active': 'L’entreprise est Platinium.',
  'platinium.toast.refuse': 'La demande de Platinium est refusée.',
  'platinium.toast.retire': 'Le Platinium est retiré à cette entreprise. Rien n’est supprimé.',
  'platinium.toast.plafond': 'Plafond atteint : {actifs} entreprises Platinium sur {plafond}.',
  'platinium.toast.erreur': 'L’action n’a pas abouti. Réessayez.',
  'platinium.fenetre.admin': 'Accès des entreprises Platinium : du {ouverture} au {fermeture} inclus.',

  // ── Encart de Mon stand ────────────────────────────────────────────────
  // 2026-10-15 (décision A de Mika) : CÔTÉ ENTREPRISE, le mot « Platinium »
  // disparaît, l'espace s'appelle « Mon espace recrutement » (encart, page,
  // garde, onglets). Le back-office (colonne, « Passer Platinium », statut)
  // et l'accord du candidat gardent « Platinium ». Mikael - chef de projet - 2026-10-15
  'platinium.encart.titre': 'Mon espace recrutement',
  'platinium.encart.titre.actif': 'Mon espace recrutement',
  'platinium.encart.titre.demande': 'Demande d’espace recrutement',
  'platinium.encart.intro':
    'Après {eventTypeDef}, continuez à chercher dans les CV des candidats qui ont donné leur accord, gardez vos coups de cœur dans un vivier et suivez chaque candidat jusqu’au recrutement.',
  'platinium.encart.demander': 'Demander l’espace recrutement',
  'platinium.encart.envoyee': 'Demande envoyée le {date}. L’organisation vous répondra.',
  'platinium.encart.envoyeeSansDate': 'Demande envoyée. L’organisation vous répondra.',
  'platinium.encart.refuse': 'Votre précédente demande n’a pas été retenue. Vous pouvez la renouveler.',
  'platinium.encart.retire': 'L’espace recrutement de votre entreprise a été fermé par l’organisation. Vous pouvez le demander à nouveau.',
  'platinium.encart.mereSeule': 'Seul le compte principal de votre entreprise peut demander l’espace recrutement.',
  'platinium.encart.ferme': 'Les demandes ne sont pas ouvertes. Adressez-vous à l’organisation.',
  'platinium.encart.actif': 'Votre espace recrutement est ouvert.',
  // 2026-10-15 : accès accordé, fenêtre pas encore ouverte (ou fermée) :
  // « est ouvert » serait faux. Mikael - chef de projet - 2026-10-15
  'platinium.encart.actif.accorde': 'Votre entreprise a accès à l’espace recrutement.',
  // 2026-10-15 : la pastille de l'encart a sa propre clé ; « platinium.statut.actif »
  // reste « Platinium » pour le back-office. Mikael - chef de projet - 2026-10-15
  'platinium.encart.pastille.actif': 'Accordé',
  'platinium.encart.actif.lien': 'Ouvrir mon espace recrutement',
  'platinium.encart.fermeture': 'Accès ouvert jusqu’au {date} inclus.',
  'platinium.encart.avant': 'Votre espace recrutement ouvrira à la fin de {eventTypeDef}, jusqu’au {date} inclus.',
  'platinium.encart.toast.ok': 'Votre demande d’espace recrutement est envoyée.',
  'platinium.encart.toast.erreur': 'La demande n’a pas pu être envoyée. Réessayez.',

  // ── Écran /exposant/platinium ─────────────────────────────────────────
  'platinium.page.titre': 'Mon espace recrutement',
  'platinium.page.intro': 'Vos recherches, votre vivier de candidats, vos entretiens et votre tableau de bord, après {eventTypeDef}.',
  'platinium.page.chargement': 'Chargement de votre espace recrutement…',
  'platinium.page.erreur': 'Votre espace recrutement n’a pas pu être chargé. Réessayez dans un instant.',
  'platinium.page.fermeture': 'Accès ouvert jusqu’au {date} inclus, encore {jours, plural, =0 {aujourd’hui seulement} one {# jour} other {# jours}}.',
  'platinium.page.onglets': 'Sections de votre espace recrutement',
  'platinium.page.onglet.recherche': 'Rechercher',
  'platinium.page.onglet.vivier': 'Mon vivier',
  'platinium.page.onglet.agenda': 'Agenda',
  'platinium.page.onglet.tableau': 'Tableau de bord',
  'platinium.page.retourStand': 'Retour à Mon stand',

  'platinium.garde.indisponible.titre': 'Espace recrutement indisponible',
  'platinium.garde.indisponible': 'L’espace recrutement n’est pas proposé sur cet événement.',
  'platinium.garde.pasPlatinium.titre': 'Votre espace recrutement n’est pas ouvert',
  'platinium.garde.pasPlatinium':
    'L’espace recrutement s’ouvre sur demande, après accord de l’organisation. Vous pouvez en faire la demande depuis Mon stand.',
  'platinium.garde.demander': 'Faire la demande depuis Mon stand',
  'platinium.garde.avant.titre': 'Votre espace recrutement n’est pas encore ouvert',
  'platinium.garde.avant': 'Il ouvrira à la fin de {eventTypeDef} et restera ouvert jusqu’au {date} inclus.',
  'platinium.garde.fermee.titre': 'Votre espace recrutement est fermé',
  'platinium.garde.fermee': 'L’accès était ouvert jusqu’au {date} inclus. Sa durée suit celle de la conservation des CV.',
  'platinium.garde.indeterminee': 'Les dates de l’accès ne sont pas encore fixées par l’organisation.',
  'platinium.garde.recruteur.titre': 'Accès recruteur désactivé',
  'platinium.garde.recruteur': 'Votre accès recruteur a été désactivé par votre entreprise.',

  // 2026-10-14, lot P6 : les textes provisoires des quatre onglets sont
  // retirés, chaque lot a remplacé le sien. Mikael - chef de projet - 2026-10-14

  // ── L'accord du candidat (texte commun au formulaire et à Mon profil) ──
  'platinium.accord.libelle':
    'J’accepte que les entreprises Platinium recherchent mon CV et me contactent pendant {duree} après {eventTypeDef}, jusqu’au {date} au plus tard',
  'platinium.accord.aide':
    'Vous pouvez retirer cet accord à tout moment : votre CV est alors retiré aussitôt, et tout ce que les entreprises avaient noté à votre sujet est effacé. Chaque consultation de votre CV est inscrite dans le journal que vous pouvez lire dans Mon CV.',
  'platinium.accord.duree': '{jours} jours',
  'platinium.accord.mineur': 'Cet accord n’est pas proposé aux mineurs sans accord parental.',
  'platinium.accord.donneLe': 'Accord donné le {date}.',
  'platinium.accord.source.formulaire': 'à l’inscription',
  'platinium.accord.source.profil': 'dans Mon profil',
  'platinium.accord.source.papier_jour_j': 'sur papier, sur place',
  'platinium.accord.source.admin': 'par l’organisation',
};
